import React from "react";

// Situação = quadradinho de cor + texto (layout "Razão"), nunca só cor. Tons reservados:
// ok (verde), warn (âmbar), info (azul), bad (vermelho, texto também vermelho), off (cinza, texto
// apagado), neutral (cinza com texto normal — "em aberto", "rascunho").
type Tone = "ok" | "warn" | "info" | "bad" | "off" | "neutral";

const TONE: Record<string, Tone> = {
  ATIVO: "ok",
  ACTIVE: "ok",
  VIGENTE: "ok",
  PAGO: "ok",
  RECEBIDO: "ok",
  AUTORIZADA: "ok",
  APROVADO: "ok",

  EM_ABERTO: "neutral",
  A_RECEBER: "neutral",
  RASCUNHO: "neutral",
  EMITIDO: "neutral",
  REGISTRADO: "neutral",

  AGENDADO: "info",
  ENVIADA: "info",
  ENVIADO: "info",
  PROCESSANDO: "info",
  TRIAL: "info",
  BETA: "info",
  PENDENTE: "warn",
  PENDING_ACTIVATION: "warn",
  MANUTENCAO: "warn",
  SUSPENSO: "warn",

  VENCIDO: "bad",
  INADIMPLENTE: "bad",
  ATRASADO: "bad",
  EXPIRADO: "bad",
  FALHA: "bad",

  REJEITADA: "off",
  REJEITADO: "off",
  CANCELADO: "off",
  CANCELADA: "off",
  DESCONTINUADO: "off",
  ENCERRADO: "off",
  INATIVO: "off",
  DISABLED: "off",

  ADMIN: "ok",
  FINANCEIRO: "info",
  SUPORTE: "neutral",
  LEITURA: "neutral",
};

const LABEL: Record<string, string> = {
  ATIVO: "Ativo",
  ACTIVE: "Ativo",
  VIGENTE: "Vigente",
  PAGO: "Pago",
  EM_ABERTO: "Em aberto",
  VENCIDO: "Vencido",
  CANCELADO: "Cancelado",
  AGENDADO: "Agendado",
  INADIMPLENTE: "Inadimplente",
  TRIAL: "Teste",
  SUSPENSO: "Suspenso",
  MANUTENCAO: "Em manutenção",
  DESCONTINUADO: "Descontinuado",
  ENCERRADO: "Encerrado",
  INATIVO: "Inativo",
  ADMIN: "Administrador",
  FINANCEIRO: "Financeiro",
  SUPORTE: "Suporte",
  LEITURA: "Leitura",
  EMITIDO: "Emitido",
  A_RECEBER: "A receber",
  RECEBIDO: "Recebido",
  ATRASADO: "Atrasado",
  EXPIRADO: "Expirado",
  FALHA: "Falha",
  RASCUNHO: "Rascunho",
  ENVIADA: "Enviada",
  ENVIADO: "Enviado",
  PROCESSANDO: "Processando",
  AUTORIZADA: "Autorizada",
  APROVADO: "Aprovado",
  REJEITADA: "Rejeitada",
  REJEITADO: "Rejeitado",
  CANCELADA: "Cancelada",
  PENDING_ACTIVATION: "Convite pendente",
  DISABLED: "Desativado",
};

export function StatusTag({ status }: { status: string }) {
  return (
    <span className="nt-st" data-tone={TONE[status] ?? "neutral"}>
      {LABEL[status] ?? status}
    </span>
  );
}
